import { CircularProgress, createTheme, Theme } from "@mui/material";
import { getLighterAndDarker } from "../helpers/color";

const borderRadius = 8;

export function generateTheme(themeColor?: string): Theme {
  const mainColor = themeColor || "#42A5F5";
  const { lighter, darker } = getLighterAndDarker(mainColor, 20);

  const brandingTheme: Theme = createTheme({
    colorSchemes: {
      light: {
        palette: {
          background: {
            paper: "#EEF2F6",
            default: "#FFFFFF",
          },
          primary: {
            dark: darker,
            main: mainColor,
            light: lighter,
            contrastText: "#FFFFFF",
          },
          success: {
            main: "#34C759",
            light: "#3EEF64",
            dark: "#2DA34F",
            contrastText: "#FFFFFF",
          },
        },
      },
      dark: {
        palette: {
          text: {
            primary: "#f8f8f8ff",
            secondary: "#CCCCCC",
          },
          background: {
            paper: "#343434ff",
            default: "#3a3a3aff",
          },
          primary: {
            dark: darker,
            main: mainColor,
            light: lighter,
            contrastText: "#FFFFFF",
          },
          success: {
            main: "#34C759",
            light: "#3EEF64",
            dark: "#2DA34F",
            contrastText: "#FFFFFF",
          },
        },
      },
    },
    typography: {
      fontFamily: "Lexend",
      fontSize: 12,
    },
    components: {
      MuiPaper: {
        defaultProps: {
          sx: {
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "background.paper" : "#FFFFFF",
          },
        },
      },
      MuiInputBase: {
        defaultProps: {
          sx: {
            border: (theme) =>
              theme.palette.mode === "dark"
                ? `1px solid ${theme.palette.divider}`
                : `1px solid #eaeaea`,
            bgcolor: (theme) =>
              theme.palette.mode === "dark"
                ? `${theme.palette.background.paper}`
                : "#F8F8F8",
            borderRadius: 1,
            p: 1,
            colorScheme: (theme) => theme.palette.mode,
          },
          inputProps: { style: { padding: 2 } },
        },
      },
      MuiButton: {
        defaultProps: {
          loadingPosition: "start",
        },
      },
      MuiIconButton: {
        defaultProps: {
          loadingIndicator: <CircularProgress />,
        },
      },
    },
    shadows: [
      "none",
      "0px 4px 10px 0px #0000001A",
      "0px 5px 22px 0px #0000001A",
      "0px 6px 24px 0px #0000001A",
      "0px 7px 26px 0px #0000001A",
      "0px 8px 28px 0px #0000001A",
      "0px 9px 30px 0px #0000001A",
      "0px 10px 32px 0px #0000001A",
      "0px 11px 34px 0px #0000001A",
      "0px 12px 36px 0px #0000001A",
      "0px 13px 38px 0px #0000001A",
      "0px 14px 40px 0px #0000001A",
      "0px 15px 42px 0px #0000001A",
      "0px 16px 44px 0px #0000001A",
      "0px 17px 46px 0px #0000001A",
      "0px 18px 48px 0px #0000001A",
      "0px 19px 50px 0px #0000001A",
      "0px 20px 52px 0px #0000001A",
      "0px 21px 54px 0px #0000001A",
      "0px 22px 56px 0px #0000001A",
      "0px 23px 58px 0px #0000001A",
      "0px 24px 60px 0px #0000001A",
      "0px 25px 62px 0px #0000001A",
      "0px 26px 64px 0px #0000001A",
      "0px 27px 66px 0px #0000001A",
    ],
    shape: {
      borderRadius,
    },
  });

  return brandingTheme;
}
